import { FC } from 'react';
// MUI
import { StepConnector } from '@mui/material';
import cx from 'classnames';
// Styles
import styles from './styles.module.scss';

interface StepperProps {
	steps: string[];
	activeStep: number;
	className?: string;
}

const Stepper: FC<StepperProps> = ({ steps, activeStep, className }) => {
	return (
		<div className={cx(styles['stepper-wrapper'], className)}>
			{steps.map((step, i) => (
				<div
					key={step}
					className={cx(styles.step, {
						[styles.step_unactive]: i > activeStep,
					})}
				>
					<p className={styles.step__title}>{step}</p>
					<StepConnector
						className={cx({
							'Mui-active': i === activeStep,
							'Mui-completed': i < activeStep,
						})}
					/>
				</div>
			))}
		</div>
	);
};
export default Stepper;
